if (!customElements.get('cart-settings-bridge')) {
  customElements.define('cart-settings-bridge', class extends HTMLElement {
    connectedCallback() {
      this.onTriggerClick = event => {
        const drawer = this.closest('.section-cart')?.querySelector('ds-cart-drawer') || document.querySelector('ds-cart-drawer')
        if (!drawer || typeof drawer.open !== 'function') return
        event.preventDefault()
        event.stopPropagation()
        drawer.open()
      }
      this.mount = this.mount.bind(this)
      this.mount()
      document.addEventListener('shopify:section:load', this.mount)
      document.addEventListener('DOMContentLoaded', this.mount, {once: true})
    }
    mount() {
      const slot = document.querySelector('[data-cart-trigger-slot]')
      const template = this.querySelector('[data-cart-trigger-template]')
      if (!slot || !template || slot === this.slot) return
      this.trigger?.removeEventListener('click', this.onTriggerClick, true)
      this.slot = slot
      slot.replaceChildren(template.content.cloneNode(true))
      const count = this.querySelector('[data-cart-count]')?.textContent
      if (count != null) slot.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count)
      this.trigger = slot.querySelector('[data-cart-trigger]')
      this.trigger?.addEventListener('click', this.onTriggerClick, true)
    }
    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onTriggerClick, true)
      document.removeEventListener('shopify:section:load', this.mount)
      document.removeEventListener('DOMContentLoaded', this.mount)
      this.trigger = null
      this.slot = null
    }
  })
}
